import { fragment, icon, node } from "~/util/dom";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import { createSubscriptionTextInfo } from "~/ui/share-position/share-position-subscription-text";
import ContextMenuItem from "~/ui/contextmenuitem";
import ContextMenu from "~/ui/contextmenu";
import { EPopOverFlow } from "~/ui/popover";
import { TRASH_FILLED_24 } from "@sznds/icons";
import createSDSIcon from "~/ui/icon";

interface ISubscriptionItemProps {
	data: ISubscriptionWithDescription;
	lang: string;
	onClick?: (event: PointerEvent) => void;
	onDelete?: (event: PointerEvent) => void;
	active: boolean;
	_: (keyInput: string, ...rest: any[]) => string;
}

export default class SubscriptionItem {
	#container: HTMLDivElement;

	#avatar: HTMLMapyAvatarElement;

	#imageAvatar: HTMLImageElement;

	#text: HTMLDivElement;

	#props: ISubscriptionItemProps;

	#contextMenu: ContextMenu;

	#etcButton: HTMLButtonElement;

	#deleteButton: HTMLButtonElement;

	constructor(props: ISubscriptionItemProps) {
		this.#props = props;
		this.#container = node("div", { className: `ui-subscription-item ${props.active ? "ui-subscription-item--active" : ""}` });
		this.#avatar = node("mapy-avatar");
		this.#imageAvatar = node("img");
		this.#text = node("div", { className: "ui-subscription-item__text" });

		this.#avatar.appendChild(this.#imageAvatar);
		this.#container.appendChild(this.#avatar);
		this.#container.appendChild(this.#text);

		this.#container.addEventListener("click", this, false);

		this.#etcButton = node("button", { type: "button", className: "ui-subscription-item__etcButton" });
		const menu = fragment();
		const deleteMenuItem = new ContextMenuItem({
			icon: createSDSIcon({
				symbol: TRASH_FILLED_24,
			}),
			text: this.#props._("sharePosition.removeSubscription"),
			onClick: event => {
				event.stopPropagation();
				this.#props.onDelete?.(event);
				this.#contextMenu.close();
			},
		});

		this.#etcButton.appendChild(icon("etc-vertical"));
		this.#etcButton.setAttribute("data-log-ignore", "1");

		menu.appendChild(deleteMenuItem.container);

		this.#contextMenu = new ContextMenu({
			anchor: this.#etcButton,
			content: menu,
			flow: EPopOverFlow.END,
		});
		this.#etcButton.addEventListener("click", () => {
			event.stopPropagation();
			this.#contextMenu.toggle();
		});

		this.#deleteButton = node("button", { type: "button", innerText: this.#props._("remove"), className: "ui-subscription-item__deleteButton" });
		this.#deleteButton.addEventListener("click", (event: PointerEvent) => {
			event.stopPropagation();
			this.#props.onDelete?.(event);
		});

		this.#updateDOM();
		this.active = this.#props.active;
	}

	destroy() {
		this.#container.removeEventListener("click", this, false);
	}

	get container() {
		return this.#container;
	}

	set data(data: ISubscriptionWithDescription) {
		this.#props.data = data;
		this.#updateDOM();
	}

	get data(): ISubscriptionWithDescription {
		return {
			...this.#props.data,
		};
	}

	set active(active: boolean) {
		this.#props.active = active;
		this.#container.classList[active ? "add" : "remove"]("ui-subscription-item--active");
		if (active) {
			this.#avatar.setAttribute("selected", "selected");
		} else {
			this.#avatar.removeAttribute("selected");
		}
	}

	#updateDOM() {
		// avatar src
		this.#imageAvatar.src = this.#props.data.user.avatarUrl;
		if (Mapy.CUS.user.premiumCrowns) {
			//this.#avatar.setAttribute("premium", "mapy");
		}

		// texty
		this.#text.innerHTML = "";
		this.#text.appendChild(createSubscriptionTextInfo(this.#props.data, this.#props.lang, this.#props._));

		// akce a barva avatara
		if (this.#props.data.sharingStatus === "active") {
			this.#container.appendChild(this.#etcButton);
			this.#deleteButton.remove();
			this.#avatar.removeAttribute("inactive");
		} else {
			this.#etcButton.remove();
			this.#container.appendChild(this.#deleteButton);
			this.#avatar.setAttribute("inactive", "inactive");
		}
	}

	handleEvent(event: PointerEvent) {
		this.#props.onClick?.(event);
	}
}
